import "./Cryptocurrency.css"
import CryptoMarket from "./Widgets/CryptoMarket";

const Cryptocurrency = () => {
    return(
      <div id="cryptocurrency">
        <h1>Cryptocurrency</h1>
        <CryptoMarket />
      </div>
    )
}

export default Cryptocurrency;